/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { RadioGroup, RadioButton } from 't3-widgets'

import { setSelectedSubscriptionOption, setSubscriptionSelectedPage } from '../../../../../../../redux/actions'

import styles from '../../pages.module.css'

const SubscriptionMenuPage = ({
    activeStep,
    intl,
    pageSelectedOption,
    setPagerFunctions,
    setSelectedPage,
    setStep
}) => {
    const dispatch = useDispatch()

    const onNext = () => {
        dispatch(setSelectedSubscriptionOption(true))
    }

    const onBack = () => {
        dispatch(setSubscriptionSelectedPage('wfsubscription'))
        setStep(activeStep - 1)
    }

    useEffect(() => {
        setPagerFunctions({
            onBack,
            onNext,
            validator: true
        })
    }, [])

    return (
        <div className={styles['content-wrapper']}>
            <div>
                <div className={styles['page-description']}>
                    <p>{intl.translate('ap_step3_para_rma')}</p>
                </div>
                <div className={styles['page-input-container']}>
                    <div className={styles['input-field']}>
                        <RadioGroup
                            key="subscriptionOptions"
                            name="options"
                            value={pageSelectedOption}
                            onChange={selectedButton => setSelectedPage(selectedButton)}
                        >
                            <RadioButton
                                label={intl.translate('ap_step3_tariffs_label')}
                                value="wfsubscription"
                                name="options"
                            />
                            <RadioButton label={intl.translate('ap_step3_rma_label')} value="rma" name="options" />
                        </RadioGroup>
                    </div>
                </div>
            </div>
        </div>
    )
}

SubscriptionMenuPage.propTypes = {
    activeStep: PropTypes.number,
    intl: PropTypes.objectOf(PropTypes.func),
    pageSelectedOption: PropTypes.string,
    setPagerFunctions: PropTypes.func,
    setSelectedPage: PropTypes.func,
    setStep: PropTypes.func
}

export { SubscriptionMenuPage }
